module.exports = __webpack_public_path__ + "img/blog4.61196b1c.jpg";